import {useState} from "react"
import { Button, Form, InputGroup } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css'
import axios from 'axios';
import {toast} from 'react-hot-toast';
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";

export default function AddQuestion(){
    const navigate = useNavigate();
    const [selectedFile, setSelectedFile] = useState(null);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [uploadStatus, setUploadStatus] = useState('');
    const [errors, setErrors] = useState({});

    const { mock_id } = useParams();
    const [newQuestion, setNewQuestion] = useState({
        question_info:'',
        question_desc:'',
        mock_id: mock_id,
        question_doc_url :'',
        question_info_doc_url :'',
        option_a: '',
        option_b: '',
        option_c: '',
        option_d: '',
        correct_option: '', // Will store "A", "B", "C", or "D"
        question_info_doc: null, 
        question_doc: null   

    })

        // Handles standard file browsing selection
    const handleImageFileChange = (field, files) => {
        // Files coming from standard inputs arrive as a file list collection array
        // We isolate the primary active binary node at index 0
        const file = files instanceof FileList ? files[0] : files;
        if (!file) return;

        // STEP A: Store the raw file binary object directly for FormData use
        setNewQuestion(prev => ({
            ...prev,
            [field]: file 
        }));

        // STEP B: Compute a separate preview path string for UI image tracking tags
        const reader = new FileReader();
        reader.onloadend = () => {
            setNewQuestion(prev => ({
                ...prev,
                [`${field}_preview`]: reader.result 
            }));
        };
        reader.readAsDataURL(file); 
    };

    // Captures clipboard paste events (Jira-style screenshot mechanism)
    const handleImagePaste = (field, e) => {
        const items = e.clipboardData?.items;
        if (!items) return;
        
        for (let i = 0; i < items.length; i++) {
            if (items[i].type.indexOf('image') !== -1) {
                const file = items[i].getAsFile(); // Generates native system File instance
                handleImageFileChange(field, file);
                e.preventDefault();
                break;
            }
        }
    };

    // Removes an image from state
    const clearImage = (field) => {
        setNewQuestion(prev => ({ ...prev, [field]: null }));
    };
    
    // const [selectedFile, setSelectedFile] = useState(null)

    const handleChange = (e)=>{
        setNewQuestion({...newQuestion, [e.target.name]: e.target.value})
    }

    // const handleFileChange = (e)=>{
    //     //setNewPaper({...newPaper, paper: e.target.files[0]})
    //     const file = e.target.files[0];
    //     if(file){
    //         setNewPaper({...newPaper, paper : file})
    //     } 
    // }


    //FIXED: Using the functional state approach and checking content matches eliminates cursor/spacebar drops
    const handleQuillChange = (field, content) => {
        setNewQuestion(prevState => {
            if (prevState[field] === content) return prevState;
            return {
                ...prevState,
                [field]: content
            };
        });
    };

    const handleSubmit = async (event)=>{
        
        event.preventDefault(); // Move to the very top line of submission thread
        
        let isValid = true;
        const newErrors = {};

        if (!newQuestion.question_desc) {
            newErrors.question_desc = 'Question is required';
            isValid = false;
        }
        if (!newQuestion.option_a) {
            newErrors.option_a = 'Provide option A';
            isValid = false;
        }
        if (!newQuestion.option_b) {
            newErrors.option_b = 'Provide option B';
            isValid = false;
        }
        if (!newQuestion.option_c) {
            newErrors.option_c = 'Provide option C';
            isValid = false;
        }
        if (!newQuestion.option_d) {
            newErrors.option_d = 'Provide option D';
            isValid = false;
        }

        setErrors(newErrors);

        if(isValid){

            const user = JSON.parse(localStorage.getItem("user"));

            // 1. Create the base data object matching your working backend JSON format
            const jsonDataPayload = {
                question_info: newQuestion.question_info,
                question_desc: newQuestion.question_desc,
                mock_id: newQuestion.mock_id,
                options: [
                    { 
                        answer_option: "A", 
                        answer_desc: newQuestion.option_a, 
                        isCorrect: newQuestion.correct_option === "A" 
                    },
                    { 
                        answer_option: "B", 
                        answer_desc: newQuestion.option_b, 
                        isCorrect: newQuestion.correct_option === "B" 
                    },
                    { 
                        answer_option: "C", 
                        answer_desc: newQuestion.option_c, 
                        isCorrect: newQuestion.correct_option === "C" 
                    },
                    { 
                        answer_option: "D", 
                        answer_desc: newQuestion.option_d, 
                        isCorrect: newQuestion.correct_option === "D" 
                    }
                ]
            };

            // 2. Initialize FormData multi-part request body
            const formData = new FormData();
            
            // CRITICAL FIX: Append the entire json blueprint under a single "data" field string
            formData.append("data", JSON.stringify(jsonDataPayload));

            // 3. Append the raw file attachments into their standalone multipart field descriptors
            if (newQuestion.question_info_doc instanceof File) {
                formData.append("question_info_doc", newQuestion.question_info_doc);
            }
            if (newQuestion.question_doc instanceof File) {
                formData.append("question_doc", newQuestion.question_doc);
            }

            console.log("FormData structured. Sending text payload:", jsonDataPayload);


            try {
                const response = await axios.post('https://coda.easylinksmw.com/api/questions/add', formData, {
                    headers : {
                        authorization : "Bearer " + user.accessToken
                    },
                    onUploadProgress : (progressEvent) => {
                    const percentCompleted = Math.round(
                        (progressEvent.loaded * 100) / progressEvent.total
                    );
                    setUploadProgress(percentCompleted);
                },           
            });
            console.log('Response: ', response.data);
            toast.success('Paper uploaded succcessfully')
            //navigate('/papers');
            //window.location.reload();

            setNewQuestion({
                question_info: '',
                question_desc:'',
                mock_id: mock_id,
                option_a: '',
                option_b: '',
                option_c: '',
                option_d: '',  
                question_info_doc: null, 
                question_doc: null                
            });

            } catch (error) {
                // The request was made and the server responded with a status code
                console.error('Upload error:', error);
                //console.error('Status code:', error.response.status);
                toast.error('Paper uploaded Failed. Try again')
                // navigate('/create');            
            } 
        }
    }        
    
        return(
            <div style={{ marginTop: 20 }}>
                <div className="row">
                    <div className="col-md-6 offset-md-3">
                    <h3 className="text-center">Add new Question</h3>
                    <Form encType="multipart/form-data" method="post">
                        
                        {/* 1. Question Statement Inputs Block */}
                        <Form.Group className="mb-4" controlId="paper_question_statement">
                            <Form.Label className="fw-bold">Question Statement</Form.Label>
                            
                            {/* Added onPaste listener to the outer wrapper container */}
                            <div 
                                onPaste={(e) => handleImagePaste('question_info_doc', e)}
                                style={{ 
                                    resize: 'vertical', overflow: 'auto', minHeight: '150px', height: '220px',       
                                    border: '1px solid #ccc', borderRadius: '4px', backgroundColor: 'white', paddingBottom: '42px'  
                                }}
                            >
                                <ReactQuill 
                                    theme="snow"
                                    name="question_info"
                                    value={newQuestion.question_info} 
                                    onChange={(content) => handleQuillChange('question_info', content)}
                                    placeholder="Input Question Information (Click here and press Ctrl+V to paste screenshot)"
                                    onKeyDown={(e) => e.stopPropagation()} 
                                    modules={{
                                        toolbar: [
                                            ['bold', 'italic', 'underline', 'strike'],
                                            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                                            ['clean']
                                        ],
                                    }}
                                    style={{ height: '100%', border: 'none' }} 
                                />
                            </div>

                            {/* Jira Attachment Action Bar Control */}
                            <div className="d-flex align-items-center gap-2 mt-2 bg-light p-2 border rounded-bottom" style={{ marginTop: '-7px' }}>
                                <input 
                                    type="file"
                                    name="question_info_doc" 
                                    accept="image/*" 
                                    id="browse_statement_img" 
                                    className="d-none" 
                                    onChange={(e) => handleImageFileChange('question_info_doc', e.target.files[0])}
                                />
                                <Button 
                                    variant="outline-secondary" 
                                    size="sm" 
                                    onClick={() => document.getElementById('browse_statement_img').click()}
                                >
                                    📎 Browse Image
                                </Button>
                                <small className="text-muted fs-7">or select text area and paste clipboard screenshot</small>
                            </div>

                            {/* Jira Thumbnail Preview Wrapper Panel */}
                            {newQuestion.question_info_doc && (
                                <div className="d-inline-block position-relative mt-3 p-2 border rounded bg-white shadow-sm" style={{ width: '140px' }}>
                                    <img 
                                        src={newQuestion.question_info_doc} 
                                        alt="Statement Attachment Preview" 
                                        className="img-thumbnail w-100" 
                                        style={{ height: '90px', objectFit: 'cover' }}
                                    />
                                    <div className="text-truncate small text-muted mt-1 px-1" style={{ fontSize: '11px' }}>statement_asset.png</div>
                                    <Button 
                                        variant="danger" 
                                        size="sm" 
                                        className="position-absolute top-0 end-0 rounded-circle py-0 px-1" 
                                        style={{ transform: 'translate(40%, -40%)', fontSize: '11px' }}
                                        onClick={() => clearImage('statement_image')}
                                    >
                                        ✕
                                    </Button>
                                </div>
                            )}
                            {errors.question_desc && <p className="error text-danger mt-1">{errors.question_desc}</p>}
                        </Form.Group>

                        {/* Question Textarea */}
                        {/* 2. Core Question Inputs Block */}
                        <Form.Group className="mb-4" controlId="paper_question">
                            <Form.Label className="fw-bold">Question</Form.Label>
                            
                            {/* Added onPaste listener to the outer wrapper container */}
                            <div 
                                onPaste={(e) => handleImagePaste('question_doc', e)}
                                style={{ 
                                    resize: 'vertical', overflow: 'auto', minHeight: '150px', height: '150px',       
                                    border: '1px solid #ccc', borderRadius: '4px', backgroundColor: 'white', paddingBottom: '42px'  
                                }}
                            >
                                <ReactQuill 
                                    theme="snow"
                                    name ="question_desc"
                                    value={newQuestion.question_desc} 
                                    onChange={(content) => handleQuillChange('question_desc', content)}
                                    placeholder="Input Question (Click here and press Ctrl+V to paste screenshot)"
                                    modules={{
                                        toolbarthumbnail: [
                                            ['bold', 'italic', 'underline', 'strike'],
                                            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                                            ['clean']
                                        ],
                                    }}
                                    style={{ height: '100%', border: 'none' }} 
                                />
                            </div>

                            {/* Jira Attachment Action Bar Control */}
                            <div className="d-flex align-items-center gap-2 mt-2 bg-light p-2 border rounded-bottom" style={{ marginTop: '-7px' }}>
                                <input 
                                    type="file"
                                    name="question_doc"  
                                    accept="image/*" 
                                    id="browse_question_img" 
                                    className="d-none" 
                                    onChange={(e) => handleImageFileChange('question_doc', e.target.files[0])}
                                />
                                <Button 
                                    variant="outline-secondary" 
                                    size="sm" 
                                    onClick={() => document.getElementById('browse_question_img').click()}
                                >
                                    📎 Browse Image
                                </Button>
                                <small className="text-muted fs-7">or select text area and paste clipboard screenshot</small>
                            </div>

                            {/* Jira Thumbnail Preview Wrapper Panel */}
                            {newQuestion.question_doc && (
                                <div className="d-inline-block position-relative mt-3 p-2 border rounded bg-white shadow-sm" style={{ width: '140px' }}>
                                    <img 
                                        src={newQuestion.question_doc} 
                                        alt="Question Attachment Preview" 
                                        className="img-thumbnail w-100" 
                                        style={{ height: '90px', objectFit: 'cover' }}
                                    />
                                    <div className="text-truncate small text-muted mt-1 px-1" style={{ fontSize: '11px' }}>question_asset.png</div>
                                    <Button 
                                        variant="danger" 
                                        size="sm" 
                                        className="position-absolute top-0 end-0 rounded-circle py-0 px-1" 
                                        style={{ transform: 'translate(40%, -40%)', fontSize: '11px' }}
                                        onClick={() => clearImage('question_image')}
                                    >
                                        ✕
                                    </Button>
                                </div>
                            )}
                            {errors.question_desc && <p className="error text-danger mt-1">{errors.question_desc}</p>}
                        </Form.Group>

                        {/* Options Selection Header */}
                        <Form.Label className="mb-2"><strong>Options</strong> (Check the circle for the correct answer)</Form.Label>

                        {/* Option A */}
                        <Form.Group className="mb-3" controlId="option_a_group">
                        <InputGroup>
                            <InputGroup.Radio
                            name="correct_option"
                            value="A"
                            checked={newQuestion.correct_option === "A"}
                            onChange={handleChange}
                            />
                            <InputGroup.Text className="bg-primary text-white px-3 fw-bold">A</InputGroup.Text>
                            <Form.Control 
                            onChange={handleChange} 
                            name="option_a" 
                            value={newQuestion.option_a}  
                            type="text" 
                            placeholder="Option A" 
                            required
                            />
                        </InputGroup>
                        {errors.option_a && <p className="error text-danger">{errors.option_a}</p>}
                        </Form.Group>

                        {/* Option B */}
                        <Form.Group className="mb-3" controlId="option_b_group">
                        <InputGroup>
                            <InputGroup.Radio
                            name="correct_option"
                            value="B"
                            checked={newQuestion.correct_option === "B"}
                            onChange={handleChange}
                            />
                            <InputGroup.Text className="bg-primary text-white px-3 fw-bold">B</InputGroup.Text>
                            <Form.Control 
                            onChange={handleChange} 
                            name="option_b" 
                            value={newQuestion.option_b}  
                            type="text" 
                            placeholder="Option B" 
                            required
                            />
                        </InputGroup>
                        {errors.option_b && <p className="error text-danger">{errors.option_b}</p>}
                        </Form.Group>

                        {/* Option C */}
                        <Form.Group className="mb-3" controlId="option_c_group">
                        <InputGroup>
                            <InputGroup.Radio
                            name="correct_option"
                            value="C"
                            checked={newQuestion.correct_option === "C"}
                            onChange={handleChange}
                            />
                            <InputGroup.Text className="bg-primary text-white px-3 fw-bold">C</InputGroup.Text>
                            <Form.Control 
                            onChange={handleChange} 
                            name="option_c" 
                            value={newQuestion.option_c}  
                            type="text" 
                            placeholder="Option C" 
                            required
                            />
                        </InputGroup>
                        {errors.option_c && <p className="error text-danger">{errors.option_c}</p>}
                        </Form.Group>

                        {/* Option D */}
                        <Form.Group className="mb-3" controlId="option_d_group">
                        <InputGroup>
                            <InputGroup.Radio
                            name="correct_option"
                            value="D"
                            checked={newQuestion.correct_option === "D"}
                            onChange={handleChange}
                            />
                            <InputGroup.Text className="bg-primary text-white px-3 fw-bold">D</InputGroup.Text>
                            <Form.Control 
                            onChange={handleChange} 
                            name="option_d" 
                            value={newQuestion.option_d}  
                            type="text" 
                            placeholder="Option D" 
                            required
                            />
                        </InputGroup>
                        {errors.option_d && <p className="error text-danger">{errors.option_d}</p>}
                        </Form.Group>

                        {/* Validation error message for correct option */}
                        {errors.correct_option && <p className="error text-danger text-center fw-bold">{errors.correct_option}</p>}

                        <Button
                        style={{ width: '100%', marginTop: '1rem' }} 
                        onClick={handleSubmit} 
                        variant="primary"
                        >
                        Submit
                        </Button>
                    </Form>
                    </div>
                </div>           
            </div>
        )
    }
